/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_RemoveInputs */

const en_shared_remove = /** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const de_shared_remove = /** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

const es_shared_remove = /** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const fr_shared_remove = /** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const nl_shared_remove = /** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

/** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */
const it_shared_remove = en_shared_remove;

/** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */
const pt_br2_shared_remove = en_shared_remove;

/** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */
const pl_shared_remove = en_shared_remove;

/** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */
const hu_shared_remove = en_shared_remove;

/** @type {(inputs: Shared_RemoveInputs) => LocalizedString} */
const ro_shared_remove = en_shared_remove;

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Shared_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_remove = /** @type {((inputs?: Shared_RemoveInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_RemoveInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_remove(inputs)
	if (locale === "de") return de_shared_remove(inputs)
	if (locale === "es") return es_shared_remove(inputs)
	if (locale === "fr") return fr_shared_remove(inputs)
	if (locale === "nl") return nl_shared_remove(inputs)
	if (locale === "it") return it_shared_remove(inputs)
	if (locale === "pt-BR") return pt_br2_shared_remove(inputs)
	if (locale === "pl") return pl_shared_remove(inputs)
	if (locale === "hu") return hu_shared_remove(inputs)
	return ro_shared_remove(inputs)
});
export { shared_remove as "shared.remove" }